<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Usuários</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span
                v-if="countFilter > 0"
                class="badge badge-light"
              >{{countFilter}}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Usuários</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6
                  class="m-0"
                >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">{{labelName}}</th>
                    <th scope="col" class="border-0">{{labelIdentity}}</th>
                    <th scope="col" class="border-0">Perfil</th>
                    <th scope="col" class="border-0">Data do cadastro</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in Users" :key="index">
                    <td></td>
                    <td class="text-left">{{user.Name}}</td>
                    <td>{{user.Identity | identity}}</td>
                    <td>{{user.UserProfilePartner.Name}}</td>
                    <td>{{user.CreatedDate | date }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >Opções</button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="GetUser(user.Id, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a class="dropdown-item" href="#" v-on:click.stop="GetUser(user.Id)">
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="RemoveUserValidate(index)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="Users == null || Users == undefined || Users.length == 0">
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormUser"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <div>
          <ValidationObserver ref="formValidation">
            <d-form-row>
              <!-- Name -->
              <d-col md="6" class="form-group">
                <label>Nome</label>
                <ValidationProvider rules="required" v-slot="{errors, invalid}">
                  <d-form-input
                    :class="validatedFormValidation | showValidateError(invalid)"
                    type="text"
                    v-model="infoUser.Name"
                    placeholder="Nome"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >{{ errors[0] }}</div>
                </ValidationProvider>
              </d-col>
              <!-- Identity -->
              <d-col md="6" class="form-group">
                <label>CPF</label>
                <ValidationProvider rules="required|min:11|identity" v-slot="{errors, invalid}">
                  <the-mask
                    :class="validatedFormValidation | showValidateError(invalid)"
                    class="form-control"
                    type="tel"
                    :mask="['###.###.###-##']"
                    v-model="infoUser.Identity"
                    placeholder="CPF"
                    :disabled="isSeeing || !isCreating"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >{{ errors[0] }}</div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <!-- Email -->
            <d-form-row>
              <d-col md="6" class="form-group mb-0">
                <label for="feEmail">E-mail</label>
                <ValidationProvider rules="required|email" v-slot="{errors, invalid}">
                  <d-form-input
                    :class="validatedFormValidation | showValidateError(invalid)"
                    type="email"
                    v-model="infoUser.Email"
                    placeholder="E-mail"
                    :disabled="isSeeing || !isCreating"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >{{ errors[0] }}</div>
                </ValidationProvider>
              </d-col>
              <!-- Phone -->
              <d-col md="6" class="form-group">
                <label for="parPhone">Telefone</label>
                <ValidationProvider rules="required|min:10" v-slot="{errors, invalid}">
                  <d-input-group seamless>
                    <d-input-group-text slot="prepend">
                      <i class="fas fa-phone-alt"></i>
                    </d-input-group-text>
                    <the-mask
                      id="parPhone"
                      class="form-control"
                      :class="validatedFormValidation | showValidateError(invalid)"
                      type="tel"
                      :mask="['(##) #####-####', '(##) ####-####']"
                      v-model="infoUser.Phone"
                      placeholder="Telefone"
                      :disabled="isSeeing && !isCreating"
                    />
                  </d-input-group>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >{{ errors[0] }}</div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <d-form-row>
              <!-- UserProfilePartner.Code -->
              <d-col :class="[isSeeing && !isCreating ? '6' : '12' ]" class="form-group">
                <label>Perfil</label>
                <ValidationProvider rules="required" v-slot="{errors, invalid}">
                  <d-select
                    v-model="infoUser.UserProfilePartner.Code"
                    :class="validatedFormValidation | showValidateError(invalid)"
                    :disabled="isSeeing"
                  >
                    <option :value="null" selected>Selecione</option>
                    <option
                      v-for="userProfilePartner in userProfiles"
                      v-bind:value="userProfilePartner.Code"
                      v-bind:key="userProfilePartner.Code"
                    >{{userProfilePartner.Name}}</option>
                  </d-select>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedFormValidation"
                  >{{ errors[0] }}</div>
                </ValidationProvider>
              </d-col>
              <!-- CreatedDate -->
              <d-col v-if="isSeeing && !isCreating" md="6" class="form-group">
                <label>Data do cadastro</label>
                <d-form-input
                  type="text"
                  v-bind:value="infoUser.CreatedDate | date('DD/MM/YYYY - HH:mm')"
                  :disabled="true"
                />
              </d-col>
            </d-form-row>
          </ValidationObserver>
        </div>
      </div>
      <template slot="modal-footer" slot-scope="{cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="AddUser()" v-if="!isSeeing || isCreating">
          {{isCreating == false ? "Salvar" : "Adicionar"}}
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="12" class="form-group">
          <d-select v-model="filter.CodeUserProfilePartner" :value="null">
            <option :value="null" selected>Perfil</option>
            <option
              v-for="userProfilePartner in userProfiles"
              v-bind:key="userProfilePartner.Code"
              v-bind:value="userProfilePartner.Code"
            >{{userProfilePartner.Name}}</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo usuário"
      v-on:click="OpenMNewUser()"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "users",
  data: function() {
    return {
      labelName: "Nome",
      labelIdentity: "CPF",
      countFilter: 0,
      filter: {
        Name: null,
        Identity: null,
        CodeUserProfilePartner: null
      },
      validatedFormValidation: false,
      loadingList: false,
      loadingModal: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      Users: [],
      infoUser: {
        Name: null,
        Identity: null,
        Email: null,
        Phone: null,
        UserProfilePartner: {
          Code: null
        }
      },
      userProfiles: [],
      isSeeing: false,
      isCreating: false,
      modalTitle: "Novo usuário"
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListUser();
    },
    "pagination.RowsPerPage": function() {
      this.ListUser();
    }
  },
  mounted() {
    this.ListUser();
    this.ListUserProfilePartner();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListUser();
    },
    ResetFilter: function() {
      this.filter = {
        Name: null,
        Identity: null,
        CodeUserProfilePartner: null,
      };
      this.ListUser();
    },
    ListUserProfilePartner: function() {
      this.$store
        .dispatch("ListUserProfilePartner")
        .then(response => {
          this.userProfiles = response;
        })
        .catch(error => {
          this.$makeToast(
            "Não foi possível buscar os perfis de usuário",
            "danger",
            "Listagem de Usuários",
            error
          );
        });
    },
    ListUser: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.CodeUserProfilePartner)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
          "Object.Identity": this.filter.Identity,
          "Object.UserProfilePartner.Code": this.filter.CodeUserProfilePartner
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListUser", { params: data })
        .then(response => {
          this.Users = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            "Não foi possível buscar os usuários",
            "danger",
            "Listagem de Usuários",
            error
          );
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
    GetUser: function(id, seeing) {
      let self = this;
      this.loadingModal = true;
      this.isCreating = false;
      this.ResetInfoUser();
      self.OpenMUser();

      this.$store
        .dispatch("GetUser", { id: id })
        .then(
          response => {
            self.infoUser = response;

            if (typeof seeing != "undefined") {
              self.isSeeing = true;
              self.modalTitle = "Detalhes do usuário";
            } else {
              self.isSeeing = false;
              self.modalTitle = "Editar usuário";
            }
          },
          error => {
            self.$makeToast(
              "Não foi possível buscar as informações do usuário",
              "danger",
              "Informações do Usuário",
              error
            );
          }
        )
        .finally(() => {
          this.loadingModal = false;
        });
    },
    RemoveUserValidate(index) {
      this.$makeMsgBox(
        "Você tem certeza que deseja remover o usuário?",
        "Confirmar",
        this.RemoveUser,
        index
      );
    },
    RemoveUser: function(i) {
      let deleted = this.Users[i];
      let self = this;

      this.$store
        .dispatch("DeleteUser", { id: deleted.Id })
        .then(() => {
          self.$makeToast(
            `O usuário foi removido da sua lista`,
            "success",
            "Usuário excluído."
          );
          self.FeedbackModal();
        })
        .catch(error => {
          self.$makeToast(
            "Não foi possível remover o Usuário, tente novamente",
            "danger",
            "Remoção de Usuário",
            error
          );
          this.$bvModal.hide("mFormUser");
        });
    },
    OpenMUser: function() {
      this.validatedFormValidation = false;
      this.$bvModal.show("mFormUser");
    },
    OpenMNewUser: function() {
      this.ResetInfoUser();
      this.isCreating = true;
      this.isSeeing = false;
      this.modalTitle = "Novo usuário";
      this.OpenMUser();
    },
    ResetInfoUser: function() {
      this.infoUser = {
        Name: null,
        Identity: null,
        Email: null,
        Phone: null,
        UserProfilePartner: {
          Code: null
        }
      };
    },
    AddUser: function() {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then(valid => {
        if (valid) {
          this.loadingModal = true;
          this.CallAddUserAPI();
        }
      });
    },
    CallAddUserAPI() {
      if (this.isCreating) {
        // Add
        this.$store
          .dispatch("AddUser", this.infoUser)
          .then(() => {
            this.$makeToast(
              "Sucesso ao adicionar o usuário",
              "success",
              "Adição de Usuário"
            );
            this.FeedbackModal();
          })
          .catch(error => {
            this.$makeToast(
              "Não foi possível adicionar o usuário",
              "danger",
              "Adição de Usuário",
              error
            );
            this.$bvModal.hide("mFormUser");
          })
          .finally(() => {
            this.loadingModal = false;
          });
      } else {
        // Update
        this.$store
          .dispatch("UpdateUser", this.infoUser)
          .then(() => {
            this.$makeToast(
              "Sucesso ao alterar o usuário",
              "success",
              "Alteração de Usuário"
            );
            this.FeedbackModal();
          })
          .catch(error => {
            this.$makeToast(
              "Não foi possível alterar o usuário",
              "danger",
              "Alteração de Usuário",
              error
            );
            this.$bvModal.hide("mFormUser");
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    FeedbackModal() {
      this.ListUser();
      this.$bvModal.hide("mFormUser");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/users.vue